import React, { useState } from "react";
import axios from "axios";
import "./style.css";
import { useAuth } from "../../Context/UserContext/index.tsx";

const AddQuestionForm = () => {
     const { username, canName, courseId, batchNo,serialNo } = useAuth()
  const [formData, setFormData] = useState({
    QuestionSetId: "",
    CourseID: "",
    QuestionId: "",
    question: "",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    option_ans: "", // will hold 'A', 'B', 'C', or 'D'
    answer: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    const {
      QuestionSetId,
      CourseID,
      QuestionId,
      question,
      option_a,
      option_b,
      option_c,
      option_d,
      option_ans,
      answer,
    } = formData;

    if (
      !QuestionSetId ||
      !CourseID ||
      !QuestionId ||
      !question ||
      !option_a ||
      !option_b ||
      !option_c ||
      !option_d ||
      !option_ans ||
      !answer
    ) {
      setError("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    // Map option_ans letter to actual option text value
    let correctOptionText = "";
    switch (option_ans) {
      case "A":
        correctOptionText = option_a;
        break;
      case "B":
        correctOptionText = option_b;
        break;
      case "C":
        correctOptionText = option_c;
        break;
      case "D":
        correctOptionText = option_d;
        break;
      default:
        setError("Please select a valid correct option.");
        setLoading(false);
        return;
    }

    const payload = {
      QuestionSetId,
      CourseID,
      QuestionId: parseInt(QuestionId, 10),
      question,
      option_a,
      option_b,
      option_c,
      option_d,
      image: null,
      option_ans: correctOptionText, // actual text of correct option
      answer,
      created_on: new Date().toISOString(),
      created_by: username,
      batch_no:"NULL",
    };

    try {
      await axios.post(
        "https://elearn-api.onrender.com/api/insertQuestion",
        payload
      );
      setSuccess("Question inserted successfully!");
      setFormData({
        QuestionSetId: "",
        CourseID: "",
        QuestionId: "",
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        option_ans: "",
        answer: "",
      });
    } catch (err) {
      console.error(err);
      setError("Failed to insert question.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-question-form">
      <h2>Add New Question</h2>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}

      <form onSubmit={handleSubmit}>
        <label htmlFor="QuestionSetId">Question Set ID</label>
        <input
          type="text"
          id="QuestionSetId"
          name="QuestionSetId"
          value={formData.QuestionSetId}
          onChange={handleChange}
          required
        />

        <label htmlFor="CourseID">Course ID</label>
        <input
          type="text"
          id="CourseID"
          name="CourseID"
          value={formData.CourseID}
          onChange={handleChange}
          required
        />

        <label htmlFor="QuestionId">Question ID</label>
        <input
          type="number"
          id="QuestionId"
          name="QuestionId"
          value={formData.QuestionId}
          onChange={handleChange}
          required
        />

        <label htmlFor="question">Question Text</label>
        <textarea
          id="question"
          name="question"
          value={formData.question}
          onChange={handleChange}
          required
          rows={3}
        />

        <label htmlFor="option_a">Option A</label>
        <input
          type="text"
          id="option_a"
          name="option_a"
          value={formData.option_a}
          onChange={handleChange}
          required
        />

        <label htmlFor="option_b">Option B</label>
        <input
          type="text"
          id="option_b"
          name="option_b"
          value={formData.option_b}
          onChange={handleChange}
          required
        />

        <label htmlFor="option_c">Option C</label>
        <input
          type="text"
          id="option_c"
          name="option_c"
          value={formData.option_c}
          onChange={handleChange}
          required
        />

        <label htmlFor="option_d">Option D</label>
        <input
          type="text"
          id="option_d"
          name="option_d"
          value={formData.option_d}
          onChange={handleChange}
          required
        />

        <label htmlFor="option_ans">Correct Option</label>
        <select
          id="option_ans"
          name="option_ans"
          value={formData.option_ans}
          onChange={handleChange}
          required
        >
          <option value="">-- Select Correct Option --</option>
          <option value="A">Option A</option>
          <option value="B">Option B</option>
          <option value="C">Option C</option>
          <option value="D">Option D</option>
        </select>

        <label htmlFor="answer">Answer Explanation</label>
        <input
          type="text"
          id="answer"
          name="answer"
          value={formData.answer}
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Insert Question"}
        </button>
      </form>
    </div>
  );
};

export default AddQuestionForm;
